import Cleave from "cleave.js"
import noUiSlider, {Options} from "nouislider"

const ranges = document.querySelectorAll<HTMLElement>(".f-range")
setRanges(ranges);

const targetElements = document.querySelectorAll(".f-range");

const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function(mutation) {
    if(mutation.type==="attributes") {

      //const ranges = document.querySelectorAll<HTMLElement>(".f-range")
      const ranges = [<HTMLElement>mutation.target]
      setRanges(ranges);
    }
  })
})
targetElements.forEach(function(targetElement){
  observer.observe(targetElement, {attributes: true});
});

function setRanges(ranges) {
  ranges.forEach((range) => {
    const sliderInput = range.querySelector<HTMLElement>(".f-range__slider")

    const {
      min: dataMin = 0,
      max: dataMax = 1,
      minStart: dataMinStart = dataMin,
      maxStart: dataMaxStart = dataMax,
    } = range.dataset

    const min = Number(dataMin)
    const max = Number(dataMax)
    const minStart = Number(dataMinStart)
    const maxStart = Number(dataMaxStart)

    const step = range.getAttribute("data-step") ? Number(range.getAttribute("data-step")) : undefined

    if (!sliderInput) return

    if (sliderInput.noUiSlider) sliderInput.noUiSlider.destroy()

    const rangeOptions: Options = {
      start: [minStart, maxStart],
      range: {
        min: min,
        max: max,
      },
      format: {
        to: function (value) {
          if (value === max) {
            return ""
          }
          return Math.round(value).toLocaleString()
        },
        from: function (value) {
          return Number(value)
        },
      },
      connect: true,
      step: step,
    }

    const slider = noUiSlider.create(sliderInput, rangeOptions)

    const inputMin = range.querySelector<HTMLInputElement>(".f-range__input.--min input")
    const inputMax = range.querySelector<HTMLInputElement>(".f-range__input.--max input")

    if (inputMin !== null && inputMax !== null) {
      const inputs = [inputMin, inputMax]

      slider.on("slide", (values, handle) => {
        inputs[handle].value = String(values[handle])
      })

      slider.on("update", (values, handle) => {
        inputs[handle].closest(".f-range__input")?.classList.toggle("--no-suffix", String(values[handle]) === "")
      })

      slider.on("change",(values, handle) => {
        const onChangeParameters = range.getAttribute('data-on-change')
        if(onChangeParameters) {
          (onChangeParameters.split(',')).forEach((onChangeParameter) => {
            if (onChangeParameter && typeof window[onChangeParameter] === "function") {
              window[onChangeParameter]()
            }
          })
        }
      })

      inputs.forEach((input) => {
        input.addEventListener("keyup", () => {
          const {value} = input
          const cleanValue = Number(value.replace(/\s/g, ""))
          const steps = slider.steps()

          if (input.closest(".f-range__input")?.classList.contains("--min")) {
            const step = steps[0]
            if (Number(step[1]) > cleanValue) return

            slider.setHandle(0, cleanValue, true, true)
          } else {
            const step = steps[1]

            if (Number(step[1]) > cleanValue) return

            slider.setHandle(1, cleanValue, true, true)
          }
        })

        new Cleave(input, {
          delimiter: " ",
          numeral: true,
        })
      })
    }
  })
}
